"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
const testimonials = [{
  author: "Sophie M.",
  quote: "\"Ankommen, Wohlfühlen, Entspannen …\nBei Linda gönne und mir immer eine Auszeit.\nUnd mein Körper kommt auch auf seine Kosten!",
  position: "Treue Kundin"
}, {
  author: "Marc R.",
  quote: "Die Lymphdrainage bei Bodyconcept Allendorf ist pure Entspannung mit sichtbaren Ergebnissen. Ein absolutes Muss für das Wohlbefinden.",
  position: "Wellness-Gast"
}];
export default function WordFromTheField() {
  return <section data-section-id="229612" id="kundenstimmen" className="relative text-foreground py-16 md:py-24 overflow-hidden bg-border">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/muddy_jobsite_background.png)] bg-cover bg-center blur-3xl scale-105 opacity-0"></div>
        <div className="absolute inset-0 bg-secondary/80 backdrop-blur-[4px]"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 min-h-[400px]">
        <div className="text-center mb-16 md:mb-24">
          <h2 className="font-default text-4xl uppercase tracking-tighter text-foreground !font-normal md:text-5xl lg:text-6xl">
            Echte <span className="text-accent-foreground !font-normal">Erfahrungen</span>
          </h2>
          <div className="w-16 h-0.5 bg-primary/20 mx-auto mt-8"></div>
        </div>

        <div className="w-full max-w-5xl mx-auto">
          <Carousel opts={{
          loop: true,
          align: "center"
        }} className="relative w-full auto">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <Card className="text-card-foreground flex flex-col gap-6 rounded-xl bg-transparent border-none ![padding:24px_0px_18px_0px] overflow-hidden shrink-0">
                    <CardContent className="flex flex-col items-center text-center p-6 md:p-10">
                      <Quote className="size-10 md:size-12 text-accent-foreground mb-8 opacity-40" />
                      <p className={`italic font-medium text-foreground max-w-4xl tracking-tight !text-2xl leading-relaxed !font-sans ![margin:0px_15.9961px_46px_15.9961px] whitespace-normal`}>
                        "{testimonial.quote}"
                      </p>
                      <div className="flex flex-col items-center tracking-widest">
                        <span className="font-default font-semibold text-lg md:text-xl text-primary mb-1">
                          {testimonial.author}
                        </span>
                        
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="flex items-center justify-center gap-4 mt-8">
              <CarouselPrevious className="rounded-lg border border-border bg-background hover:bg-accent hover:text-accent-foreground hover:border-accent size-10 transition-colors" />
              <CarouselNext className="rounded-lg border border-border bg-background hover:bg-accent hover:text-accent-foreground hover:border-accent size-10 transition-colors" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}